import { render, staticRenderFns } from "./baseUpload.vue?vue&type=template&id=ce665442"
import script from "./baseUpload.vue?vue&type=script&lang=js"
export * from "./baseUpload.vue?vue&type=script&lang=js"
import style0 from "./baseUpload.vue?vue&type=style&index=0&id=ce665442&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports